import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_CHANNELS_AUTHENTICATE } from 'ducks/drawers/types'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import NoticeBar from 'components/NoticeBar'
import { selectMailboxByStates } from 'selectors/mailboxes/selectMailboxByStates'
import { selectCurrentMailboxId } from 'selectors/mailboxes/selectCurrentMailboxId'

import styles from './styles.less'

export default function GmailDisconnected({ isManager }) {
  const ticketListMailboxId = useSelector(selectCurrentMailboxId)
  const disconnectedMailboxes = useSelector(state =>
    selectMailboxByStates(state, ['disconnected'])
  )
  const firstMailbox = disconnectedMailboxes[0] || {}
  const currentMailboxId = ticketListMailboxId || firstMailbox.id
  const { drawerId, openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
    lazyLoad: true,
    closeIgnoresStack: true,
  })

  const mailboxName = !ticketListMailboxId ? ` ${firstMailbox.name}` : ''

  const onOpen = useCallback(
    () => {
      openAddDrawer(currentMailboxId, {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerChannelType', 'google'),
          ...buildDrawerQueryParam(drawerId, 'drawerSource', 'inbox'),
        },
      })
    },
    [openAddDrawer, currentMailboxId, drawerId]
  )

  let callToActionContent = `Please contact your administrator to reconnect your ${app.t(
    'mailbox'
  )} now.`
  if (isManager) {
    callToActionContent = (
      <a className={styles.demoBarLinkInlineWarning} onClick={onOpen}>
        Please reconnect your{mailboxName} {app.t('mailbox')} now.
      </a>
    )
  }

  return (
    <NoticeBar type="warning">
      Oh no, looks like this {app.t('mailbox')} has been disconnected!&nbsp;
      {callToActionContent}
    </NoticeBar>
  )
}
